(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-auto-submit]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => select.form.requestSubmit());
    });
    root.querySelectorAll('.collection-scroll').forEach(wrapper => {
      if (wrapper.dataset.ready) return;
      wrapper.dataset.ready = 'true';
      const row = wrapper.querySelector('.collection-navigation');
      const controls = wrapper.querySelector('.collection-scroll-controls');
      const back = wrapper.querySelector('[data-collections-back]');
      const next = wrapper.querySelector('[data-collections-next]');
      const sync = () => {
        controls.hidden = row.scrollWidth <= row.clientWidth + 2;
        back.disabled = row.scrollLeft <= 2;
        next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
      };
      back.addEventListener('click', () => row.scrollBy({ left: -row.clientWidth * .75 }));
      next.addEventListener('click', () => row.scrollBy({ left: row.clientWidth * .75 }));
      row.addEventListener('scroll', sync, { passive: true });
      new ResizeObserver(sync).observe(row);
      sync();
    });
    const navigation = root.querySelector('[data-navigation]');
    if (navigation && !navigation.dataset.ready) {
      navigation.dataset.ready = 'true';
      const desktop = window.matchMedia('(min-width: 900px)');
      const syncNavigation = () => { navigation.open = desktop.matches; };
      syncNavigation();
      desktop.addEventListener('change', syncNavigation);
      navigation.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !desktop.matches) { navigation.open = false; navigation.querySelector('summary').focus(); }
      });
    }
    root.querySelectorAll('[data-variant-select]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      const pills = select.form.querySelector('[data-variant-pills]');
      if (pills) {
        select.closest('[data-variant-fallback]').hidden = true;
        pills.hidden = false;
        pills.querySelectorAll('[data-variant-pill]').forEach(radio => {
          radio.addEventListener('change', () => {
            if (!radio.checked) return;
            select.value = radio.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      }
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        pills?.querySelectorAll('[data-variant-pill]').forEach(radio => { radio.checked = radio.value === option.value; });
        const form = select.closest('form');
        const button = form.querySelector('[data-add-button]');
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? 'Sold out' : 'Add to bag';
        const info = form.closest('.product-info');
        info.querySelector('[data-stock-note]').textContent = option.dataset.stock || '';
        form.querySelector('[data-express-checkout]').hidden = button.disabled;
        const gallery = form.closest('.product-detail').querySelector('.product-gallery');
        const media = [...gallery.querySelectorAll('[data-media-id]')].find(item => item.dataset.mediaId === option.dataset.mediaId);
        if (media) {
          gallery.querySelectorAll('.is-selected').forEach(item => item.classList.remove('is-selected'));
          media.classList.add('is-selected');
          gallery.scrollTo({ left: 0 });
        }
        const price = form.closest('.product-info').querySelector('[data-product-price]');
        price.textContent = option.dataset.price + ' ';
        if (option.dataset.compare) { const old = document.createElement('s'); old.textContent = option.dataset.compare; price.append(old); }
        const url = new URL(window.location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
      });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
